'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var CascaderWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    position: relative;\n"], ["\n    width: ", ";\n    position: relative;\n"])), function (_a) {
    var isFlex = _a.isFlex;
    return (isFlex ? '100%' : 'fit-content');
});
var templateObject_1;

export { CascaderWrapper };
//# sourceMappingURL=Cascader.css.js.map
